import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout/Layout'; // 라우터 컴포넌트가 있다면
import AuthService from './services/authService'; // 인증 서비스 import
import api from './utils/api';

const queryClient = new QueryClient();

function App() {
    useEffect(() => {
        // 앱 시작 시 인증 상태 확인 및 토큰 설정
        const token = AuthService.getToken();

        // 현재 경로가 로그인 페이지가 아닐 때만 인증 체크
        const currentPath = window.location.pathname;

        if (AuthService.isUsableToken(token)) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            console.log('앱 시작: 인증 토큰이 헤더에 설정되었습니다.');
        } else if (currentPath !== '/login') {
            // 토큰이 없고 로그인 페이지가 아니면 로그인 페이지로 리다이렉션
            window.location.href = '/login';
        }
    }, []);

    return (
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <Layout />
                <ToastContainer position="top-right" />
            </QueryClientProvider>
        </HelmetProvider>
    );
}

export default App;
